module.exports = __webpack_public_path__ + "img/television3.f77a348c.png";